export const getScheduleEndTime = (userId) => {
  const mockSchedules = {
    1: '2026-02-02T18:00:00Z',
  };

  return mockSchedules[userId] || null;
};
